import React from "react";
import usePagination from "./../../hooks/usePagination";
import { useQueryClient } from "react-query";
import { 
  ErrorBoundary,
  Loaders,
  Paginator,
  ResponsiveTable,
 } from "./../../components";
import { OverviewSubheader }  from "./../layouts";
import { TextButton } from "./../buttons"
import {
  usePreofferSubscribersList,
  useExportPreofferSubscribersList,
} from "../../queries/preoffer";
import { formatMoney } from "./../../utils/currrency";
import { formatDate } from "./../../utils/datetime";

function SubscribersList({preofferId, downloadEnabled}) {
  const queryClient = useQueryClient();
  const pageConfig = usePagination();
  const subscribers = usePreofferSubscribersList({preoffer_id: preofferId, ...pageConfig.current})

  const _exportPreofferSubscriberList = useExportPreofferSubscribersList({preoffer_id: preofferId})
  const exportSubscribers = async () => {
    queryClient.refetchQueries(
      ['preoffer', preofferId, 'exportsubscriberlist'],
      {
        enabled: true,
      }
    );
  }

  const tableData = React.useMemo(
    () => {
      if (subscribers.isSuccess)
        return subscribers.data.data
      else
        return []
    },
    [subscribers]
  );

  const columns = React.useMemo(
    () => {
      if (subscribers.isSuccess){
        return [
          {
            Header: 'Subscriber name',
            accessor: 'name'
          },
          {
            Header: 'Email',
            accessor: 'email',
          },
          {
            Header: 'Amount',
            accessor: 'amount',
            Cell: ({value}) => formatMoney(value)
          },
          {
            Header: 'Country',
            accessor: 'country',
          },
          {
            Header: 'Subscribed At',
            accessor: 'created_at',
            Cell: ({value}) => formatDate(value)
          },
        ]
      }
      else{
        return []
      }
    },
    [subscribers]
  );

  if(subscribers.isLoading)
    return <Loaders.ListPageLoader />

  return (
    <ErrorBoundary>
      <OverviewSubheader
        left='Subscribers'
        right={
          downloadEnabled ? <TextButton title="Export All" onClick={exportSubscribers} /> : null
        }
        tooltipDesc="All the subscribers in this pre-launch."
      />
      <Paginator
        theme='dark'
        onPage={pageConfig.setPage}
        meta={subscribers.data.pagy}
      />
      <ResponsiveTable title="Subscribers" columns={columns} data={tableData} />
    </ErrorBoundary>
  );
}

export default SubscribersList;